/**
 * High level router.
 *
 * Note: It's recommended to compose related routes in internal router
 * components (e.g: `src/app/modules/Auth/pages/AuthPage`, `src/app/BasePage`).
 */

import { FC } from 'react'
import { Routes, Route, BrowserRouter, Navigate } from 'react-router-dom'
import { PrivateRoutes } from './PrivateRoutes'
import { App } from '../App'
import { AuthLayout } from '../modules/auth/AuthLayout'
import { AuthPage, Logout } from '../modules/auth'
import ResetPassword from '../modules/auth/components/ResetPassword'
import { ErrorsPage } from '../modules/errors/ErrorsPage'

/**
 * Base URL of the website.
 *
 * @see https://facebook.github.io/create-react-app/docs/using-the-public-folder
 */
const { PUBLIC_URL } = process.env

const AppRoutes: FC = () => {
  const currentUser = localStorage.getItem('userData')
  return (
    <BrowserRouter basename={PUBLIC_URL}>
      <Routes>
        <Route element={<App />}>
          {/* <>
              <Route path='/*' element={<PrivateRoutes />} />
              <Route index element={<Navigate to='/viewrequest' />} />
            </> */}

          <Route path='error/*' element={<ErrorsPage />} />
          <Route path='logout' element={<Logout />} />
          <Route element={<AuthLayout />}><Route path='/vendor/reset-password/:id/:otp/:token' element={<ResetPassword />} /></Route>

          {currentUser ? (
            <>
              <Route path='/*' element={<PrivateRoutes />} />
              <Route index element={<Navigate to='/clients' />} />
              {/* <Route index element={<Navigate to='/viewrequest' />} /> */}
            </>
          ) : (
            <>
              <Route element={<AuthLayout />}><Route path='/vendor/reset-password/:id/:otp/:token' element={<ResetPassword />} /></Route>
              <Route path='auth/*' element={<AuthPage />} />
              <Route path='*' element={<Navigate to='/auth' />} />
            </>
          )}
        </Route>
      </Routes>
    </BrowserRouter>
  )
}

export { AppRoutes }
